
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Churchgatetopune() {



    const cardData =
    {
        keyword: 'Church Gate to Pune Cab Service ',
        heading: 'Mauli Cabs: Church Gate to Pune Cab Service ',
        headingDescription: 'Mauli Cabs offers efficient and comfortable Churchgate to Pune cab service, ensuring a seamless travel experience from South Mumbai’s historic business hub to your destination in Pune. Whether you are commuting for business, a personal trip, or a weekend getaway, we offer a fleet of well-maintained vehicles including sedans, SUVs, and premium cabs to match your needs. With professional drivers, on-time pickups, transparent pricing, and no hidden charges, Mauli Cabs guarantees a safe, reliable, and stress-free journey from Churchgate to Pune.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located about 30 km from Pune, Sinhagad Fort is a favorite spot for trekking and offers panoramic views and a rich historical background."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganesh temples in Maharashtra, this temple is revered for its magnificent idol and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Parvati Hill",
        "description": "Parvati Hill offers a serene temple complex atop a hill with beautiful views of the city and is one of the oldest heritage sites in Pune."
    },
    {
        "title": "Osho Garden and Ashram",
        "description": "Located in Koregaon Park, this peaceful garden and spiritual center draws global visitors for meditation and relaxation in tranquil surroundings."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum showcases a fascinating collection of artifacts, including musical instruments, weaponry, and antiques, celebrating India’s cultural heritage."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Inspired by a Japanese design, this beautifully landscaped garden is perfect for calm walks and nature photography."
    },
    {
        "title": "Rajiv Gandhi Zoological Park",
        "description": "Also known as Katraj Zoo, this park houses various species of animals and a dedicated snake park, popular with families and kids."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, this ancient monument offers spiritual solace in the middle of the city."
    }
],

"services": [
    {
      "name": "Churchgate to Pune Taxi Fare",
      "description": "Book a taxi from Churchgate to Pune at affordable and transparent fares. Enjoy a comfortable ride with professional drivers and multiple vehicle options."
    },
    {
      "name": "Mumbai Central to Pune Cab",
      "description": "Travel from Mumbai Central to Pune with our reliable cab service. Choose from sedans, SUVs, or premium cars at competitive rates."
    },
    {
      "name": "CST to Pune Cab Service",
      "description": "Book a cab from CST (Chhatrapati Shivaji Terminus) to Pune for a smooth and convenient journey. Comfortable vehicles and clear pricing guaranteed."
    },
    {
      "name": "Mazdock to Pune Taxi Service",
      "description": "Get a dependable taxi from Mazdock, Mumbai to Pune. Ideal for work or leisure travel with well-maintained cars and experienced drivers."
    },
    {
      "name": "Mumbai Central to Pune One Way Cab",
      "description": "Looking for a one-way cab from Mumbai Central to Pune? Enjoy flexible booking, affordable pricing, and safe travel with our cab service."
    },
    {
      "name": "Nariman Point to Pune Taxi Fare",
      "description": "Book a taxi from Nariman Point to Pune with competitive fares. Enjoy scenic travel and professional service throughout your journey."
    },
    {
      "name": "Gateway of India to Pune Cab",
      "description": "Travel comfortably from Gateway of India to Pune in our premium cabs. Enjoy smooth service with fixed pricing and multiple car options."
    },
    {
      "name": "Worli Mumbai to Pune Cab",
      "description": "Book a cab from Worli to Pune for a hassle-free trip. Comfortable vehicles and experienced drivers ensure a smooth ride."
    },
    {
      "name": "Best Cab Service Mumbai to Pune",
      "description": "Experience the best cab service from Mumbai to Pune with a fleet of well-maintained vehicles and courteous drivers. Competitive prices and reliable service guaranteed."
    },
    {
      "name": "Mumbai Central to Pune Innova Crysta",
      "description": "Travel in luxury from Mumbai Central to Pune in an Innova Crysta. Perfect for families or groups, offering spacious seating and a premium ride experience."
    },
    {
      "name": "Fort Mumbai to Pune Cab Service",
      "description": "Book a cab from Fort, Mumbai to Pune with our trusted taxi service. Comfortable travel, timely service, and clear pricing for every trip."
    }
  ],
  "tableData": [
    ["Churchgate to Pune Taxi Fare", "Mumbai Central to Pune Cab"],
    ["CST to Pune Cab Service", "Mazdock to Pune Taxi Service"],
    ["Mumbai Central to Pune One Way Cab", "Nariman Point to Pune Taxi Fare"],
    ["Gateway of India to Pune Cab", "Worli Mumbai to Pune Cab"],
    ["Best Cab Service Mumbai to Pune", "Mumbai Central to Pune Innova Crysta"],
    ["Fort Mumbai to Pune Cab Service", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Cab Service from Church Gate to Pune",
        "WhyChoosedescription": "Mauli Cabs offers a reliable and timely cab service from Church Gate to Pune, ensuring that you enjoy a comfortable and hassle-free ride, whether for business or leisure."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Travel in comfort with our fleet of well-maintained sedans, SUVs, and premium vehicles. All our cabs are air-conditioned, sanitized regularly, and designed to provide ample space for a relaxing journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Knowledge",
        "WhyChoosedescription": "Our professional drivers are experienced and familiar with the Church Gate to Pune route, ensuring a smooth ride and the best possible route to avoid traffic and delays."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive pricing with no hidden charges. The fare is transparent and fixed, so you’ll know exactly what to expect for your Church Gate to Pune trip."
    },
    {
        "WhyChooseheading": "Available 24/7 for Your Convenience",
        "WhyChoosedescription": "Mauli Cabs operates 24/7, ensuring you can travel at any time, day or night. Whether you're catching a late-night flight or need an early morning ride, we’ve got you covered."
    },
    {
        "WhyChooseheading": "Real-Time Booking and Updates",
        "WhyChoosedescription": "Book your cab instantly through our website or app. Get real-time updates on your driver’s location, ETA, and ride status, ensuring you're always in the loop during your journey."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Cabs",
        "WhyChoosedescription": "We prioritize your safety and comfort. All of our cabs are sanitized regularly, and our drivers follow strict hygiene protocols to ensure a safe and clean travel experience."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Pay conveniently using UPI, debit/credit cards, wallets, or cash. Mauli Cabs offers multiple secure payment options for a hassle-free transaction process."
    }
]



























    }

    const faqData = [
        {
            question: 'How do I book a cab from Church Gate to Pune with Mauli Cabs?',
            answer: 'Booking a cab from Church Gate to Pune is simple with Mauli Cabs. Just visit our website or app, enter "Church Gate" as your pickup location and "Pune" as your destination. Choose your preferred vehicle type and confirm the booking. If you need help, our customer support team is available 24/7.',
        },
        {
            question: 'What types of cabs are available for the Church Gate to Pune route?',
            answer: 'Mauli Cabs offers a variety of vehicles for your trip from Church Gate to Pune, including Hatchbacks, Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose the best option based on your comfort, luggage, and group size.',
        },
        {
            question: 'Is the fare fixed for the Church Gate to Pune cab service?',
            answer: 'Yes, the fare is fixed for your journey from Church Gate to Pune. It includes tolls, fuel, taxes, and driver charges, with no hidden fees. You’ll see the full fare before confirming your booking.',
        },
        {
            question: 'How long does the journey from Church Gate to Pune take?',
            answer: 'The journey usually takes around 3.5 to 5 hours, depending on traffic and road conditions. To avoid delays, we suggest starting early or avoiding peak traffic hours for a smoother ride.',
        },
        {
            question: 'Can I book a one-way or round-trip cab from Church Gate to Pune?',
            answer: 'Yes, you can book either a one-way or round-trip cab from Church Gate to Pune. If you plan to return to Church Gate on the same or next day, a round-trip booking is more economical.',
        },
        {
            question: 'Is the Church Gate to Pune cab service available 24/7?',
            answer: 'Yes, Mauli Cabs provides 24/7 service for the Church Gate to Pune route. You can book a cab at any time, whether for an early morning or late-night journey.',
        },
        {
            question: 'Can I carry extra luggage on the Church Gate to Pune journey?',
            answer: 'Yes, you can carry extra luggage. For large or bulky items, we recommend booking a larger vehicle, such as an SUV or Innova Crysta, to ensure a comfortable and spacious ride.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Amit Sharma",
            position: "Consultant",
            text: "I often travel from Church Gate to Pune for work, and Mauli Cabs has always been reliable. The drivers are professional, the vehicles are clean and comfortable, and the service is always punctual. Highly recommended!",
            image: "/img/testimonial/testimonial-thumb-1-75.png",
        },
        {
            name: "Ms. Neha Reddy",
            position: "Project Manager",
            text: "I booked a cab from Church Gate to Pune for a business trip. The journey was smooth and hassle-free, and the driver was very courteous. The vehicle was spacious and clean, making the long drive comfortable. I will definitely use Mauli Cabs again!",
            image: "/img/testimonial/testimonial-thumb-1-76.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Church Gate to Pune Cab Service",
        "description": "Book a comfortable and reliable cab from Church Gate to Pune with Mauli Cabs. Enjoy your journey in a variety of vehicles such as Innova, Ertiga, and more for a seamless experience.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "2505"
        }
      };
      
     
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Church Gate to Pune Cab Service | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book a cab from Church Gate to Pune with Mauli Cabs for a smooth and hassle-free ride. Choose from a variety of vehicles like Innova, Ertiga, and others for your trip."
        />
        <meta
          name="keywords"
          content="church gate to pune taxi fare, mumbai central to pune cab, cst to pune cab service, mazdock to pune taxi service, mumbai central to pune one way cab, nariman point to pune taxi fare, gateway of india to pune cab, worli mumbai to Pune cab, best cab service mumbai to pune, mumbai central to pune innova crysta, fort mumbai to pune cab service"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/121.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Churchgatetopune;